<template>
    <div class="document-container d-flex flex-column justify-content-center">
      <div class="circle">{{ document.index }}</div>
        <button v-if="document.showDelete" class="document-delete-button" @click="$parent.handleDeletingOtherDocuments(document)">
            <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <div v-if="document.showUploadComplete" class="document-upload-completed">
            <i class="fa fa-check" aria-hidden="true"></i>
        </div>
        <!-- <div class="document-inside-container d-flex justify-content-center">{{ document.name }}</div> -->
        <h6 class="ml-5 mt-3">Nom</h6>
        <input class="document-inside-container d-flex justify-content-center" type="text" v-model="document.name"/>
        <div class="document-upload-progress-circle">
            <vue-ellipse-progress v-if="document.progress" :progress="document.progress" :size="50" />
        </div>
        <div style="position: relative;" v-if="!document.showActionButtons">
          <div>
            <label :for="document.name" class="document-inside-button"><div><i class="fa fa-paperclip fa-2x upload-file-icon" aria-hidden="true"></i></div><div class="d-flex justify-content-center document-inside-button-button"><span class="upload-file-text">Charger un fichier</span></div> <div>ou faire glisser un fichier ici</div></label>
          </div>
          <div class="input-upload-file-custom">
            <input :id="document.name" class="input-button-upload-file-and-drop" type="file" @change="handleFileUpload">
          </div>
        </div>
        <div class="d-flex justify-content-around mx-5 mb-3 mt-1" v-if="document.showActionButtons">
            <button @click="downloafUpload(diplomesPath ? diplomesPath: document.path)"><i class="fa fa-download fa-lg little-icon-color" aria-hidden="true"></i></button>
            <button @click="deleteUpload(diplomesPath ? diplomesPath: document.path)"><i class="fa fa-trash fa-lg little-icon-color" aria-hidden="true"></i></button>
        </div>
    </div>
</template>

<script>
import {storage} from '../../firebase/app';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { VueEllipseProgress } from "vue-ellipse-progress";

export default {
    name: "upload-file",
    components: { VueEllipseProgress },
    props: ['document'],
    data() {
        return {
            uploadTask: ref(null),
            showActionButtons: true,
        }
    },
    mounted() {
    },
    methods : {
    pauseUpload(){
      this.uploadTask.pause();
    },

    resumeUpload(){
      this.uploadTask.resume();
    },

    cancelUpload(){
      this.uploadTask.cancel();
      this.document.progress = 0;
      this.document.showActionButtons = false;
      this.$forceUpdate(); 
    },
    deleteUpload(pathFile){
        const storageRef = ref(storage, pathFile);
        deleteObject(storageRef).then(() => {
          this.document.showUploadComplete = false;
          this.document.showActionButtons = false;
          this.document.progress = 0
          this.$forceUpdate(); 
        }).catch((error) => {
          console.error(error);
        });
    },

    downloafUpload(pathToFile) {
      getDownloadURL(ref(storage, pathToFile))
        .then((url) => {
          const xhr = new XMLHttpRequest()
          xhr.responseType = 'blob';
          xhr.open('GET', url)
          xhr.send()
          xhr.onload = function () {
            const blob = new Blob([xhr.response])
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = pathToFile
            a.click()
          }
        })
        .catch((error) => {
          // Handle any errors
          console.error(error);
        });
    },

    handleFileUpload(event) {
      // console.warn("event before : ", event);
      // console.log("from handle File Upload : ", `uploadedDocuments/${this.$store.state.user.informations.reference}/${event.target.files[0].name}`);
      // console.log("document : ", this.document);
      this.document.showActionButtons = true;
      this.$forceUpdate(); 
      const storageRef = ref(storage, `uploadedDocuments/${this.$store.state.user.informations.reference}/${event.target.files[0].name}`);
      this.uploadTask = uploadBytesResumable(storageRef, event.target.files[0]);
      this.uploadTask.on('state_changed', 
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.warn("progress: ", Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100) );
          this.document.progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          this.$forceUpdate(); 
          // console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case 'paused':
              // console.log('Upload is paused');
              break;
            case 'running':
              // console.log('Upload is running');
              break;
          }
        }, 
        (error) => {
          // Handle unsuccessful uploads
        }, 
        () => {
          this.document.showUploadComplete = true;
          this.$forceUpdate(); 
          this.diplomesPath = `uploadedDocuments/${this.$store.state.user.informations.reference}/${event.target.files[0].name}`;
          this.document.path = `uploadedDocuments/${this.$store.state.user.informations.reference}/${event.target.files[0].name}`
          // console.log("Diplomes Path : ", `uploadedDocuments/${this.$store.state.user.informations.reference}/${event.target.files[0].name}`);
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          getDownloadURL(this.uploadTask.snapshot.ref).then((downloadURL) => {
            // console.log('File available at', downloadURL);
          });
        }
      );
    },

    }
}

</script>

<style scoped>
.document-container {
  background-color: #F6F8FF;
  border-radius: 15px;
  padding-left: 60px;  /* Add padding to the left */
}

.document-inside-container {
  background-color: #FFFFFF;
  margin: 0 20px 10px 20px;
  color: #1F88FF;
  padding: 10px;
  border-radius: 10px;
  text-align:center
}

.document-inside-container:focus {
  outline: none;
  border: 2px solid #1F88FF ;
}


.document-inside-button {
  background-color: #FFFFFF;
  margin: 10px 20px;
  padding: 10px;
  border-radius: 10px;
  color: #5A6169;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 5px dotted #DFE1E5;
}

.document-inside-button:hover {
  cursor: pointer;
}

.upload-file-text {
  margin-left: 7px;
  text-align: center;
  display: block;
}

.upload-file-icon {
  display: block;
  margin-bottom: 10px;
}

.document-upload-progress-circle {
  text-align: center;
  color: #1F88FF;
}

.document-delete-button {
  position: absolute;
  top: 0;
  right: 0;
  color: #FC452D;
  background-color: #FDDAD5;
  border-radius: 5px;
  height: 25px;
  width: 25px;
}

.document-upload-completed {
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  padding-top: 3px;
  color: #17C671;
  background-color: #C8F1DD;
  border-radius: 5px;
  height: 25px;
  width: 25px;
}

.input-upload-file-custom {
  /* opacity: 0;  */
  /* z-index: -1; */
  /* position: absolute;  */
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

}

.input-button-upload-file-and-drop[type='file'] {
  opacity:0 ;
  width: 100%;
  height: 100%;
}

.document-inside-button-button {
  background-color: #1F88FF;
  padding: 5px 10px;
  border-radius: 5px;
  color: #FFFFFF;
  margin-bottom: 5px;
}

.input-button-upload-file-and-drop:hover {
  cursor: pointer;
}

.little-icon-color {
  color: #1F88FF;
}

.circle {
    position: absolute;
    width: 50px;    
    height: 75px;   
    left: 20px;    
    top: 50%;       
    transform: translateY(-50%); 
    background-color: white;
    border-radius: 40%;
    display: flex;
    justify-content: center; 
    align-items: center;
    text-align: center;
    color: #4F78E2;
    font-weight: 700;
    font-size: 25px;
}

</style>